export default __webpack_public_path__ + "static/media/paused-sub-bg@3x.ba53f820.png";